import { AnnSacksLogo } from './icons/AnnSacks.mjs';
import { KallistaLogo } from './icons/Kallista.mjs';
import { KlafsLogo } from './icons/Klafs.mjs';
import { KlafsSaunaAndSpaLogo } from './icons/KlafsSaunaAndSpa.mjs';
import { KohlerLogo } from './icons/Kohler.mjs';
import { KohlerBoldLogo } from './icons/KohlerBold.mjs';
import { MiraLogo } from './icons/Mira.mjs';
import { RobernLogo } from './icons/Robern.mjs';
import { SprigLogo } from './icons/Sprig.mjs';
import { SterlingLogo } from './icons/Sterling.mjs';
import { StudioKohlerLargeLogo } from './icons/StudioKohlerLarge.mjs';
import { StudioKohlerSmallLogo } from './icons/StudioKohlerSmall.mjs';

const BrandLogoPath = {
  Kohler: KohlerLogo,
  "Kohler Bold": KohlerBoldLogo,
  "Studio Kohler Large": StudioKohlerLargeLogo,
  "Studio Kohler Small": StudioKohlerSmallLogo,
  "Ann Sacks": AnnSacksLogo,
  Sterling: SterlingLogo,
  Kallista: KallistaLogo,
  Robern: RobernLogo,
  Mira: MiraLogo,
  Sprig: SprigLogo,
  Klafs: KlafsLogo,
  "Klafs Sauna and Spa": KlafsSaunaAndSpaLogo
};

export { BrandLogoPath };
